import { useEffect, useState } from 'react'
import { ChecklistPhase } from '@oneethos/shared'
import { LoanApplicationPhase } from './loan-application-phase'
import { LoanFundingPhase } from './loan-funding-phase'
import { Comment } from './comment'

const PhaseTab = ({ label, targetPhase, currentPhase, onClick, className }) => {
  const isActive = targetPhase === currentPhase

  const finalClassName = `
    border text-center py-3 flex-grow-1 pointer 
    ${isActive ? 'bg-primary-subtle border-primary-subtle' : ''}
    ${className || ''}
  `
  return (
    <div onClick={onClick} className={finalClassName} >
      {label}
    </div>
  )
}

export const ChecklistItems = ({ project, onChange }) => {
  const [phase, setPhase] = useState(ChecklistPhase.LoanApplication)
  const isPrequalified = project.isPrequalified === 'yes'
  const isProjectClosed = project.isClosed

  useEffect(() => {
    if (project.nTPGiven) {
      setPhase(ChecklistPhase.LoanFunding)
    }
  }, [project.nTPGiven])

  return (
    <div
      aria-disabled={!isPrequalified && isProjectClosed}
      {...((!isPrequalified && isProjectClosed) ? { inert: '' } : {})}
      className={(!isPrequalified && isProjectClosed) ? 'gray-out' : ''}
    >
      <div className='d-flex w-100 my-3'>
        <PhaseTab
          label="1 - Loan Application"
          onClick={() => setPhase(ChecklistPhase.LoanApplication)}
          targetPhase={ChecklistPhase.LoanApplication}
          currentPhase={phase}
          className="rounded-start-2"
        />
        <PhaseTab
          label="2 - Loan Funding"
          onClick={() => setPhase(ChecklistPhase.LoanFunding)}
          targetPhase={ChecklistPhase.LoanFunding}
          currentPhase={phase}
          className="rounded-end-2"
        />
      </div>
      {project.notesVisibleToInstallers ? <div className='mb-3'>
        <Comment text={project.notesVisibleToInstallers} />
      </div> : null}
      {phase === ChecklistPhase.LoanApplication && <LoanApplicationPhase project={project} onChange={onChange} />}
      {phase === ChecklistPhase.LoanFunding && <LoanFundingPhase project={project} onProjectChange={onChange} />}
    </div>
  )
}

export default ChecklistItems
